$('.owl-carousel.slides').owlCarousel({
	items: 1,
	nav: false,
	center: true,
	URLhashListener: true,
	startPosition: '#zero',
	smartSpeed: 800,
	autoHeight: true,

	// onInitialized: function() {
	// 	owl.find('.owl-item').each(function(index) {
	// 		$(this).find('.service-card').attr('data-position', index);
	// 	});
	// 	},
	// 	mouseDrag: false,
	// 	touchDrag: true
});

$('.owl-carousel.slides').on('changed.owl.carousel', function (event) {
	var current = event.item.index;
	var hash = $(event.target).find('.owl-item').eq(current).find('.item').attr('data-hash');
	$('.' + hash).addClass('active');
});
$('.owl-carousel.slides').on('change.owl.carousel', function (event) {
	var current = event.item.index;
	var hash = $(event.target).find('.owl-item').eq(current).find('.item').attr('data-hash');
	$('.' + hash).removeClass('active');
});
